import { buildFormDefinition } from "../../../libs/utils/forms";

export const quotationPopupFormDefinition = buildFormDefinition({
    documentType: {
        label: "Número de documento",
        key: "documentType",
        isNumeric: true,
    },
    documentNumber: {
        key: "documentNumber",
        isNumeric: true,
        placeholder: "Ingresar número",
        maxLength: 11,
    },
    contactNames: {
        label: "Nombre completo del contacto",
        key: "contactNames",
        isAlpha: true,
        placeholder: "Ingresa nombres completos",
        maxLength: 80,
    },
    contactPhone: {
        label: "Número de celular",
        key: "contactPhone",
        isNumeric: true,
        placeholder: "Ingresar celular",
        maxLength: 9,
    },
    contactEmail: {
        label: "Email",
        key: "contactEmail",
        placeholder: "Ingresar email",
        maxLength: 50,
    },
    monthlyAmount: {
        label: "Monto mensual de la\nplanilla total",
        key: "monthlyAmount",
        isCurrency: true,
        placeholder: "S/ 00.00",
    },
    rangeOfEmployees: {
        label: "Rango de\ntrabajadores",
        key: "rangeOfEmployees",
    },
    yesNo: {
        key: "yesNo",
    },
    employeesHaveValidAge: {
        key: "employeesHaveValidAge",
    },
    termsAndConditions: {
        key: "termsAndConditions",
    },
});
